import * as React from "react"
const SvgComponent = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={11}
        height={14}
        fill="none"
        {...props}
    >
        <path
            fill="#3B3B3B"
            d="M.438 14A.432.432 0 0 1 0 13.562a.45.45 0 0 1 .438-.437h.437v-1.203c0-.875.273-1.723.793-2.406L3.582 7 1.668 4.512a4.03 4.03 0 0 1-.793-2.407V.875H.437A.432.432 0 0 1 0 .437.45.45 0 0 1 .438 0h9.624a.47.47 0 0 1 .438.438.45.45 0 0 1-.438.437h-.437v1.23c0 .875-.3 1.723-.82 2.407L6.89 7l1.914 2.516c.52.683.82 1.53.82 2.406v1.203h.438a.47.47 0 0 1 .437.438.45.45 0 0 1-.438.437H.438Zm8.312-.875v-1.203a3.17 3.17 0 0 0-.629-1.86L5.988 7.274c-.136-.164-.136-.382 0-.52l2.133-2.788a3.17 3.17 0 0 0 .629-1.86V.875h-7v1.23c0 .684.219 1.34.629 1.86l2.105 2.789c.137.137.137.355 0 .52L2.38 10.061a2.994 2.994 0 0 0-.629 1.86v1.203h7Zm-3.5-7.438a.44.44 0 0 1-.355-.164l-1.75-2.187a.371.371 0 0 1-.055-.438c.082-.164.219-.273.41-.273H7c.164 0 .3.11.383.273a.371.371 0 0 1-.055.438l-1.75 2.187a.427.427 0 0 1-.328.165ZM4.402 3.5l.848 1.066.82-1.066H4.402Zm-.465 6.125h2.626c.164 0 .3.11.382.246l.875 1.75c.055.137.055.3-.027.438a.399.399 0 0 1-.356.191H3.063c-.164 0-.3-.055-.382-.191a.495.495 0 0 1-.028-.438l.875-1.75a.508.508 0 0 1 .41-.246Zm-.19 1.75h2.98l-.438-.875H4.184l-.438.875Z"
        />
    </svg>
)
export default SvgComponent
